import React, { useEffect } from 'react'

import Footer from 'client/components/Footer'
import Head from 'client/pages/Home/Head'
import Header from 'client/components/Header'
import Page from 'src/comps/Page'
import Content from 'src/pages/signup'
import { getServerSideProps as getServerSidePropsHandler } from 'src/pages/signup/server'
import type { ConfigType } from 'src/types/config'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { getLoggedIn, getLoginData } from 'client/contexts/Login/selectors'
import { buildRedirectLoginUrl } from 'src/utils/getRedirectLoginUrl'
import type { ListOfAncillary } from '@s4l/stayforlong/booking/ListOfAncillary'

const pageId = 'signUp'

interface ISignUpPageProps {
  config: ConfigType & { cookieReturnUrl: string | null }
  referrer: string | null
  ancillariesJSON: ReturnType<ListOfAncillary['toJSON']>
}

const SignUpPage = ({ config, referrer, ancillariesJSON }: ISignUpPageProps) => {
  const { cookieReturnUrl } = config

  const router = useRouter()
  const isLoggedIn = useSelector(getLoggedIn)
  const customer = useSelector(getLoginData)

  useEffect(() => {
    if (!isLoggedIn) return
    if (!customer?.email) return

    if (globalThis.window && 'ReactNativeWebView' in globalThis.window) {
      const reactNativeWebView = globalThis.window.ReactNativeWebView as {
        postMessage: (message: string) => void
      }

      reactNativeWebView.postMessage(
        JSON.stringify({
          type: 'SIGN_UP_SUCCESS',
          user: { email: customer.email },
        })
      )
    }

    const urlToRedirect = buildRedirectLoginUrl(referrer, cookieReturnUrl)
    router.push(urlToRedirect)
  }, [isLoggedIn, customer, cookieReturnUrl, referrer, router])

  return (
    <Page config={config} pageId={pageId}>
      <Head />
      <Header pageId={pageId} hasLogin={false} backButton ancillariesJSON={ancillariesJSON} />
      <Content returnUrl={cookieReturnUrl} />
      <Footer />
    </Page>
  )
}

export const getServerSideProps = getServerSidePropsHandler

SignUpPage.pageId = pageId
SignUpPage.pagePathView = '/signup'

export default SignUpPage
